/**
 * Generate default indicators for a given strategy
 */
export function generateIndicatorsForStrategy(strategyKey: string): any[] {
  const key = (strategyKey || 'trend').toLowerCase();

  if (key === 'trend' || key === 'trend_following') {
    return [
      { key: 'sma', period: 20 },
      { key: 'sma', period: 50 },
      { key: 'macd', fastPeriod: 12, slowPeriod: 26, signalPeriod: 9 },
      { key: 'adx', period: 14 },
      { key: 'momentum', period: 14 }
    ];
  }

  if (key === 'scalping') {
    return [
      { key: 'ema', period: 9 },
      { key: 'ema', period: 21 },
      { key: 'rsi', period: 14, overbought: 70, oversold: 30 },
      { key: 'stochastic', k: 14, d: 3, smooth: 3 }
    ];
  }

  if (key === 'swing' || key === 'swing_trading') {
    return [
      { key: 'sma', period: 50 },
      { key: 'sma', period: 200 },
      { key: 'rsi', period: 14, overbought: 70, oversold: 30 },
      { key: 'macd', fastPeriod: 12, slowPeriod: 26, signalPeriod: 9 }
    ];
  }

  // Default fallback for other strategies
  return [
    { key: 'sma', period: 20 },
    { key: 'rsi', period: 14, overbought: 70, oversold: 30 }
  ];
}
